import React from "react";
import { Form } from "react-bootstrap";

const RangeSlider = ({
  label = "Range Slider", // Default label
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  unit = "", // e.g., "Agents"
  symbol = true,
  dollor = false,
}) => {
  const formatValue = (num) => {
    return num >= 1000 ? `${(num / 1000).toFixed(2)}K` : num;
  };
  const progress = ((value - min) / (max - min)) * 100 + "%";

  return (
    <div className="range-slider-container body-font">
      <div
        className="d-flex flex-wrap flex-row align-items-center fw-medium"
        style={{ marginBottom: "18.3px", gap: "2%" }}
      >
        <div style={{ width: "74%" }}>
          <Form.Label className="slider-label">{label}</Form.Label>
        </div>
        <div className="d-flex justify-content-end" style={{ width: "24%" }}>
          <span
            className="slider-value fs-6 text-center"
            style={{ maxWidth: "112px", width: "100%" }}
          >
            {dollor && "$"} {formatValue(value)} {unit}
          </span>
        </div>
      </div>

      <div>
        <input
          type="range"
          className="custom-slider"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          style={{
            "--progress": progress,
            background: `linear-gradient(to right, #7a5af8 0%, #7a5af8 ${progress}, #e4e1ff ${progress}, #e4e1ff 100%)`,
          }}
        />
        <div className="d-flex justify-content-between fs-6 gray-color fw-normal">
          {" "}
          <span>
            {dollor && "$"}
            {formatValue(min)} {unit}
          </span>
          <span>
            {dollor && "$"}
            {formatValue(max)}
            {symbol ? "+" : ""} {unit}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
